import styles from './FormField.module.css';

// Shared label+input+error wrapper. The input itself is passed as children
// so this stays a thin layout component rather than reimplementing every
// input type (text/select/textarea) that the app's forms already use.
export default function FormField({ id, label, error, required, children }) {
  return (
    <div className={styles.field}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
      )}
      {children}
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
}
